import { render, staticRenderFns } from "./DeactiveUniRequest.vue?vue&type=template&id=35cacd7e&"
import script from "./DeactiveUniRequest.vue?vue&type=script&lang=js&"
export * from "./DeactiveUniRequest.vue?vue&type=script&lang=js&"
import style0 from "./DeactiveUniRequest.vue?vue&type=style&index=0&id=35cacd7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports